// extracted by mini-css-extract-plugin
export default {"updateApp":"updateApp-module--update-app--eGuGP","updateAppIcon":"updateApp-module--update-app-icon--rdCmg","updateAppText":"updateApp-module--update-app-text--clUa5"};